// Soorten huishouden en het beurtrooster (golf 6b, 0043_huishoudtypes; feedback oprichter 26 sep,
// docs/onderzoek/feedback-26-sep.md §3). De vraag "Wie wonen er hier?" bij het aanmelden,
// Instellingen · Soort huishouden met de voorvertoning, de woorden per soort en het beurtrooster.
// Toon: je-vorm, korte zinnen, werkwoorden op knoppen. Geen kindertaal bij volwassen soorten.
export const appHouseholdsNl = {
    // ---- Aanmelden: de eerste vraag --------------------------------------------------------------
    question: 'Wie wonen er in huis?',
    questionBody: 'Dan zetten we klaar wat bij jullie past. Je kunt alles later nog veranderen, er gaat nooit iets verloren.',
    types: {
        family: {
            name: 'Gezin met kinderen',
            body: 'Ouders met kinderen. Agenda, klusjes met sterren, brengen en halen.',
        },
        two_home: {
            name: 'Gezin met twee huizen',
            body: 'De kinderen wonen ook deels bij de andere ouder. Rustig en neutraal.',
        },
        couple: {
            name: 'Stel',
            body: 'Twee volwassenen. Een gedeelde agenda, boodschappen en wat er te doen is.',
        },
        solo: {
            name: 'Alleen',
            body: 'Grip op werk, sport en afspraken. Kort en overzichtelijk.',
        },
        student: {
            name: 'Studentenhuis',
            body: 'Een eerlijk schoonmaakrooster, boodschappen en een prikbord. Het bord in de gang weet wie de afwas moet doen.',
        },
        shared: {
            name: 'Huisgenoten',
            body: 'Een gedeelde woning met volwassenen. Een eerlijk rooster en een bord in de gang.',
        },
        cohousing: {
            name: 'Woongroep of hofje',
            body: 'Eigen woningen met een gedeelde ruimte. Een agenda voor de gemeenschappelijke ruimte, berichten en wie schoonmaakt.',
        },
        senior: {
            name: 'Ouderen thuis',
            body: 'Zelfstandig thuis. Grote letters, afspraken, herinneringen (ook voor medicijnen) en het weer.',
        },
        care: {
            name: 'Ouderen thuis, familie kijkt mee',
            body: 'Iemand die alleen woont, met familie die op afstand meekijkt. Grote letters, weinig knoppen.',
        },
    },
    /** Korte naam in Instellingen en in meldingen. */
    short: {
        family: 'Gezin',
        two_home: 'Gezin met twee huizen',
        couple: 'Stel',
        solo: 'Alleen',
        student: 'Studentenhuis',
        shared: 'Huisgenoten',
        cohousing: 'Woongroep of hofje',
        senior: 'Ouderen thuis',
        care: 'Ouderen thuis met familie',
    },
    /** Vervolgvraag bij Ouderen thuis (live r1): ja = care (familie kijkt mee), nee = senior. */
    seniorFamilyQuestion: 'Kijkt er familie mee op afstand?',
    yes: 'Ja',
    no: 'Nee',
    laterNote: 'Wonen er meerdere generaties in één huis? Kies Gezin met kinderen.',
    modulesOn: 'Dit zetten we voor jullie aan',
    modulesOnHint: 'Klopt dit? Je kunt elk onderdeel later aan- of uitzetten bij Instellingen.',
    confirm: 'Klopt, verder',
    // ---- Instellingen · Soort huishouden -----------------------------------------------------------
    settingsTitle: 'Soort huishouden',
    settingsBody: 'Gezin, huisgenoten, alleen …',
    settingsIntro: 'De soort bepaalt welke onderdelen standaard aan staan, hoe de app eruitziet en een paar woorden. Er wordt nooit iets gewist.',
    current: 'Nu gekozen',
    choose: 'Kies een andere soort',
    previewTitle: 'Wat verandert er?',
    turnsOn: 'Gaat aan',
    turnsOff: 'Gaat uit',
    turnsOffNote: 'Wat erin staat, blijft bewaard. Zet je het later weer aan, dan is alles er nog.',
    kept: 'Blijft zoals jullie het kozen',
    nothingChanges: 'De onderdelen blijven zoals ze zijn. Alleen het uiterlijk en een paar woorden veranderen.',
    lookChanges: 'Ook het uiterlijk past zich aan.',
    resetChoices: 'Ook onze eigen keuzes bij Modules terugzetten naar de standaard',
    apply: 'Wissel naar {name}',
    cancel: 'Niet wisselen',
    toast: 'Jullie huishouden is nu: {name}. Er is niets gewist.',
    onlyParents: 'Alleen een beheerder kan dit veranderen.',
    // ---- Woorden per soort (woordenset uit @amumin/domain WORD_SET_OF) -------------------------------
    words: {
        family: {
            members: 'Gezinsleden',
            profileTitle: 'Wat past bij jullie gezin?',
            weatherBody: 'Jas, laarzen of zonnebrand: we zeggen het op de momenten dat de kinderen de deur uit gaan.',
            adult: 'Ouder',
            tasks: 'Taken',
            cleaning: 'Schoonmaak',
            household: 'gezin',
            admin: 'Ouder',
        },
        adults: {
            members: 'Wie wonen hier',
            profileTitle: 'Wat past bij jullie?',
            weatherBody: 'Jas, paraplu of zonnebrand: we zeggen het net voor je de deur uit gaat.',
            adult: 'Volwassene',
            tasks: 'Taken',
            cleaning: 'Schoonmaak',
            household: 'huishouden',
            admin: 'Beheerder',
        },
        shared: {
            members: 'Huisgenoten',
            profileTitle: 'Wat past bij jullie huis?',
            weatherBody: 'Jas, paraplu of zonnebrand: op het bord in de gang, net voor je de deur uit gaat.',
            adult: 'Huisgenoot',
            tasks: 'Taken',
            cleaning: 'Schoonmaak',
            household: 'huis',
            admin: 'Beheerder',
        },
        care: {
            members: 'Familie',
            profileTitle: 'Wat past bij jullie?',
            weatherBody: 'Jas, paraplu of zonnebrand: we zeggen het net voor je de deur uit gaat.',
            adult: 'Volwassene',
            tasks: 'Taken',
            cleaning: 'Schoonmaak',
            household: 'huishouden',
            admin: 'Mantelzorger',
        },
    },
    /** Begroeting op Vandaag zonder gezinswoorden. */
    greetingHouse: 'Goed om je te zien',
    // ---- Aanmelden: stap met eerste taken voor andere soorten --------------------------------------
    wizardRotationTitle: 'Een eerlijk rooster',
    wizardRotationBody: 'Keuken, badkamer, gang, vuilnis en afwas rouleren elke week, en elke avond kookt iemand anders. Het bord in de gang laat zien wie aan de beurt is.',
    wizardAdultsTitle: 'Klaar voor de start',
    wizardAdultsBody: 'Zet je afspraken in de agenda en houd bij wat er te doen is. Je telefoon geeft een seintje als dat helpt.',
    wizardMembersShared: 'Wie wonen er in het huis? Je kunt iedereen later een eigen login geven.',
    // ---- Beurtrooster ------------------------------------------------------------------------------
    /** Golf 6b fixer r1: woorden bij "alleen" (enkelvoud; de rest van de volwassen set blijft). */
    soloWords: {
        members: 'Wie hoort erbij',
        profileTitle: 'Wat past bij jou?',
        profileBody: 'Kies keuken, geloof en eten, dan zie je vooral wat bij jou past. Het hoeft niet.',
    },
    /** Live r1: woorden bij een woongroep of hofje (bovenop de volwassen set). */
    cohousingWords: {
        members: 'Bewoners',
        profileTitle: 'Wat past bij jullie woongroep?',
        household: 'woongroep',
        adult: 'Bewoner',
    },
    /** Golf 6b fixer r1: toon per soort (geen kindertaal bij volwassen soorten; gezin = standaard). */
    tone: {
        adults: {
            membersTitle: 'Wie wonen hier',
            membersIntro: 'Iedereen die op het bord staat. De kleur van ieder zie je overal terug.',
            membersAdd: 'Persoon',
            membersAddLong: 'Persoon toevoegen',
            membersNew: 'Nieuwe persoon',
            namePlaceholder: 'Bijvoorbeeld Noor',
            face: 'Pictogram',
            kidLockTitle: 'Slot op de tablet',
            kidLockBody: 'Een pincode voordat iemand op de tablet iets afvinkt. Standaard uit.',
            exportAll: 'Iedereen',
            devicesIntro: 'De tablets waarop jullie bord draait.',
            library: 'Ideeën voor taken',
            libraryIntro: 'Kies een taak en voor wie hij is.',
            wizardMembersTitle: 'Wie wonen er?',
            wizardMembersBody: 'Geef iedereen een eigen kleur. Die zie je overal terug.',
            noTasksTitle: 'Geen taken vandaag',
            noTasksBody: 'Alles is bij.',
            tasksWidget: 'Taken vandaag',
            tasksAll: 'Alle taken',
            tasksEmptyBody: 'Begin met iets kleins, zoals de was of de planten water geven.',
            exportBody: 'Download de agenda als .ics-bestand, voor iedereen of per persoon.',
            dataBody: 'Een kopie van jullie gegevens als bestand (JSON), ook de keuzes bij {profile}. Je bevestigt eerst met je wachtwoord.',
            dataAll: 'Alles',
            privacyEntryBody: 'Alles downloaden, iemand weghalen of het bord verwijderen.',
            /** Golf 6b fixer r2: onder "Goedkeuring nodig" (zonder punten, zonder ouders). */
            approvalHint: 'Iemand anders kijkt de taak na voordat hij als klaar telt.',
            /** Golf 6b fixer r2: Meekijken door AMUMIN zonder "ouder" en "gezinsbord". */
            supportIntro: 'Heb je hulp nodig? Dan kan AMUMIN tijdelijk met jullie meekijken, alleen lezen. Jij bepaalt hoe lang, en elke beheerder kan het altijd meteen stoppen.',
            supportOff: 'Staat uit. Niemand van AMUMIN kan jullie bord zien.',
            supportSees: 'AMUMIN ziet dan: de namen van iedereen op het bord, de titels van afspraken van vandaag en de 6 dagen daarna (in een titel kan iets staan als Tandarts; afspraken met een geloofspictogram zoals moskee of kerk niet), de kamers en de tablets. Niet: geloof, gezondheid, school, e-mailadressen of foto’s. Elke keer meekijken zie je hieronder.',
        },
        solo: {
            membersTitle: 'Wie hoort erbij',
            membersIntro: 'Jij, en wie je er later bij zet. Je kleur zie je overal terug.',
            membersAdd: 'Persoon',
            membersAddLong: 'Persoon toevoegen',
            membersNew: 'Nieuwe persoon',
            namePlaceholder: 'Bijvoorbeeld Noor',
            face: 'Pictogram',
            kidLockTitle: 'Slot op de tablet',
            kidLockBody: 'Een pincode voordat iemand op de tablet iets afvinkt. Standaard uit.',
            exportAll: 'Alles',
            devicesIntro: 'De tablets waarop je bord draait.',
            library: 'Ideeën voor taken',
            libraryIntro: 'Kies een taak die je vaker doet.',
            wizardMembersTitle: 'Nog iemand erbij?',
            wizardMembersBody: 'Je staat er zelf al op. Hoort er nog iemand bij, bijvoorbeeld voor gedeelde afspraken? Voeg die hier of later toe.',
            noTasksTitle: 'Geen taken vandaag',
            noTasksBody: 'Alles is bij.',
            tasksWidget: 'Taken vandaag',
            tasksAll: 'Alle taken',
            tasksEmptyBody: 'Begin met iets kleins, zoals de was of de planten water geven.',
            exportBody: 'Download de agenda als .ics-bestand, voor iedereen of per persoon.',
            dataBody: 'Een kopie van jullie gegevens als bestand (JSON), ook de keuzes bij {profile}. Je bevestigt eerst met je wachtwoord.',
            dataAll: 'Alles',
            privacyEntryBody: 'Alles downloaden, iemand weghalen of het bord verwijderen.',
            approvalHint: 'Je kijkt de taak zelf na voordat hij als klaar telt.',
            supportIntro: 'Heb je hulp nodig? Dan kan AMUMIN tijdelijk met je meekijken, alleen lezen. Jij bepaalt hoe lang, en je kunt het altijd meteen stoppen.',
            supportOff: 'Staat uit. Niemand van AMUMIN kan je bord zien.',
            supportSees: 'AMUMIN ziet dan: de namen van iedereen op het bord, de titels van afspraken van vandaag en de 6 dagen daarna (in een titel kan iets staan als Tandarts; afspraken met een geloofspictogram zoals moskee of kerk niet), de kamers en de tablets. Niet: geloof, gezondheid, school, e-mailadressen of foto’s. Elke keer meekijken zie je hieronder.',
        },
        shared: {
            membersTitle: 'Huisgenoten',
            membersIntro: 'Iedereen die in het huis woont. De kleur van ieder zie je overal terug.',
            membersAdd: 'Huisgenoot',
            membersAddLong: 'Huisgenoot toevoegen',
            membersNew: 'Nieuwe huisgenoot',
            namePlaceholder: 'Bijvoorbeeld Sanne',
            face: 'Pictogram',
            kidLockTitle: 'Slot op de tablet',
            kidLockBody: 'Een pincode voordat iemand op de tablet in de gang iets afvinkt. Standaard uit.',
            exportAll: 'Hele huis',
            devicesIntro: 'De tablets waarop het bord in huis draait.',
            library: 'Ideeën voor taken',
            libraryIntro: 'Kies een taak en wie hem doet.',
            wizardMembersTitle: 'Wie wonen er?',
            wizardMembersBody: 'Wie wonen er in het huis? Je kunt iedereen later een eigen login geven.',
            noTasksTitle: 'Geen taken vandaag',
            noTasksBody: 'Kijk op het rooster wie wat doet.',
            tasksWidget: 'Taken vandaag',
            tasksAll: 'Alle taken',
            tasksEmptyBody: 'Begin met iets kleins, zoals de vuilnis buiten zetten.',
            exportBody: 'Download de agenda als .ics-bestand, voor iedereen of per persoon.',
            dataBody: 'Een kopie van jullie gegevens als bestand (JSON), ook de keuzes bij {profile}. Je bevestigt eerst met je wachtwoord.',
            dataAll: 'Hele huis',
            privacyEntryBody: 'Alles downloaden, iemand weghalen of het bord verwijderen.',
            approvalHint: 'Een huisgenoot kijkt de taak na voordat hij als klaar telt.',
            supportIntro: 'Heb je hulp nodig? Dan kan AMUMIN tijdelijk met jullie meekijken, alleen lezen. Jij bepaalt hoe lang, en elke beheerder in huis kan het altijd meteen stoppen.',
            supportOff: 'Staat uit. Niemand van AMUMIN kan het bord van jullie huis zien.',
            supportSees: 'AMUMIN ziet dan: de namen van iedereen op het bord, de titels van afspraken van vandaag en de 6 dagen daarna (in een titel kan iets staan als Tandarts; afspraken met een geloofspictogram zoals moskee of kerk niet), de kamers en de tablets. Niet: geloof, gezondheid, school, e-mailadressen of foto’s. Elke keer meekijken zie je hieronder.',
        },
        care: {
            membersTitle: 'Familie',
            membersIntro: 'Iedereen die meehelpt of op het bord staat. De kleur van ieder zie je overal terug.',
            membersAdd: 'Persoon',
            membersAddLong: 'Persoon toevoegen',
            membersNew: 'Nieuwe persoon',
            namePlaceholder: 'Bijvoorbeeld Anja',
            face: 'Pictogram',
            kidLockTitle: 'Slot op de tablet',
            kidLockBody: 'Een pincode voordat iemand op de tablet iets afvinkt. Standaard uit.',
            exportAll: 'Iedereen',
            devicesIntro: 'De tablets waarop het bord draait.',
            library: 'Ideeën voor taken',
            libraryIntro: 'Kies een taak en voor wie hij is.',
            wizardMembersTitle: 'Wie helpen er mee?',
            wizardMembersBody: 'Zet iedereen erbij die meehelpt of op het bord moet staan. Ieder krijgt een eigen kleur.',
            noTasksTitle: 'Geen taken vandaag',
            noTasksBody: 'Alles is bij.',
            tasksWidget: 'Taken vandaag',
            tasksAll: 'Alle taken',
            tasksEmptyBody: 'Begin met iets kleins, zoals medicijnen of boodschappen.',
            exportBody: 'Download de agenda als .ics-bestand, voor iedereen of per persoon.',
            dataBody: 'Een kopie van jullie gegevens als bestand (JSON), ook de keuzes bij {profile}. Je bevestigt eerst met je wachtwoord.',
            dataAll: 'Alles',
            privacyEntryBody: 'Alles downloaden, iemand weghalen of het bord verwijderen.',
            approvalHint: 'Een beheerder kijkt de taak na voordat hij als klaar telt.',
            supportIntro: 'Heb je hulp nodig? Dan kan AMUMIN tijdelijk met jullie meekijken, alleen lezen. Jij bepaalt hoe lang, en elke beheerder kan het altijd meteen stoppen.',
            supportOff: 'Staat uit. Niemand van AMUMIN kan jullie bord zien.',
            supportSees: 'AMUMIN ziet dan: de namen van iedereen op het bord, de titels van afspraken van vandaag en de 6 dagen daarna (in een titel kan iets staan als Tandarts; afspraken met een geloofspictogram zoals moskee of kerk niet), de kamers en de tablets. Niet: geloof, gezondheid, school, e-mailadressen of foto’s. Elke keer meekijken zie je hieronder.',
        },
    },
    rotation: {
        title: 'Beurtrooster',
        intro: 'Klussen rouleren eerlijk: wie aan de beurt was, sluit achteraan aan. Wie weg is, slaat een beurt over en is daarna weer als eerste aan de beurt.',
        thisWeek: 'Deze week',
        today: 'Vandaag',
        nextUp: 'Hierna',
        weekOf: 'week van {date}',
        nobody: 'Niemand doet mee',
        done: 'Gedaan door {name}',
        notYet: 'Nog niet gedaan',
        swapped: 'Geruild',
        skipped: '{name} is weg',
        swap: 'Ruilen',
        swapTitle: 'Wie doet {duty} {period}?',
        swapPeriodWeek: 'deze week',
        swapPeriodDay: 'vandaag',
        swapUndo: 'Ruil terugdraaien',
        swapSaved: '{name} doet {duty}',
        swapRemoved: 'De ruil is teruggedraaid',
        away: 'Afwezig',
        awayTitle: 'Iemand is een tijdje weg',
        awayBody: 'Op vakantie of weg voor werk? Die slaat een beurt over en is daarna weer als eerste aan de beurt.',
        awayWho: 'Wie',
        awayFrom: 'Van',
        awayTo: 'Tot en met',
        awayAdd: 'Afwezig zetten',
        awayRemove: 'Weer thuis',
        awayItem: '{name}: {from} tot en met {to}',
        awaySaved: '{name} staat afwezig',
        awayRemoved: '{name} is weer thuis',
        awayInvalid: 'De einddatum ligt vóór de begindatum.',
        empty: 'Nog geen beurtrooster',
        emptyBody: 'Maak een rooster met keuken, badkamer, gang, vuilnis, afwas en koken. Daarna kun je klussen weghalen of toevoegen bij Schoonmaak.',
        setup: 'Maak het beurtrooster',
        setupDone: '{count} klussen staan in het rooster',
        setupNothing: 'Deze klussen staan al in het rooster',
        weekly: 'Elke week',
        daily: 'Elke dag',
        others: 'Andere klussen',
        othersBody: 'Klussen uit Schoonmaak die nog niet rouleren.',
        makeWeekly: 'Elke week rouleren',
        makeDaily: 'Elke dag rouleren',
        stopRotating: 'Niet meer rouleren',
        rotatingOn: '{duty} rouleert nu',
        rotatingOff: '{duty} rouleert niet meer',
        onBoard: 'Het bord in de gang toont wie er deze week aan de beurt is. Afvinken kan daar met een tik.',
        duties: {
            kitchen: 'Keuken',
            bathroom: 'Badkamer',
            hallway: 'Gang en trap',
            trash: 'Vuilnis',
            dishes: 'Afwas',
            cooking: 'Koken',
        },
    },
};
//# sourceMappingURL=householdsApp.nl.js.map